"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledIconSvg=exports.StyledIcon=void 0;var _styledComponents=_interopRequireDefault(require("styled-components"));var _constants=require("../_constants");var _utils=require("./_utils");function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e};}const StyledIcon=exports.StyledIcon=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  vertical-align: middle;
  display: ${props=>(0,_utils.getDisplay)(props.sDisplay)};
  height: ${props=>(0,_utils.getSize)(props.sSize,_constants.MEDIA_SIZES.S)};
  width: ${props=>(0,_utils.getSize)(props.sSize,_constants.MEDIA_SIZES.S)};

  @media (${_constants.MEDIA.TABLET}) {
    height: ${props=>(0,_utils.getSize)(props.sSize,_constants.MEDIA_SIZES.M)};
    width: ${props=>(0,_utils.getSize)(props.sSize,_constants.MEDIA_SIZES.M)};
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    height: ${props=>(0,_utils.getSize)(props.sSize,_constants.MEDIA_SIZES.L)};
    width: ${props=>(0,_utils.getSize)(props.sSize,_constants.MEDIA_SIZES.L)};
  }
`;const StyledIconSvg=exports.StyledIconSvg=_styledComponents.default.svg`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  transition: fill 0.32s ease-out;
  fill: ${props=>props.fill||(0,_utils.getColor)(props.sColor)};
  color: ${props=>(0,_utils.getColor)(props.sColor)};
  ${_ref=>{let{stroke}=_ref;return stroke&&`stroke: ${stroke}`;}}
`;